<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate (ngSubmit)="save()">
    <modal-header [plugin]="plugin" [menuModal]="menuModal" [menuComponent]="menuComponent"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table" *ngIf="obsolescences?.length && !processing; else empty">
          <tr class="th-plugin-line--header">
            <td class="th-plugin-line--data" style="width: 50%">
              <span>{{ 'plugins.obsolescences.obsolescence' | translate }}</span>
            </td>
            <td class="th-plugin-line--data" style="width: 20%">
              <span>{{ 'plugins.obsolescences.urgency' | translate }}</span>
            </td>
            <td class="th-plugin-line--data" style="width: 20%">
              <span>{{ 'plugins.upgrades.status' | translate }}</span>
            </td>
            <td style="width: 10%"></td>
          </tr>
          <tr
            class="th-plugin-line-td--checkbox"
            [class.th-plugin-line--opacity-50]="obsolescence.Status === 'already-installed'"
            *ngFor="let obsolescence of obsolescences"
          >
            <td>
              <span>
                {{ obsolescence.Name }}
              </span>
            </td>
            <td>
              <span>
                {{ 'plugins.obsolescences.urgencies.' + obsolescence.Urgency | translate }}
              </span>
            </td>
            <td>
              <span>
                {{ 'plugins.obsolescences.statuses.' + obsolescence.Status | translate }}
              </span>
            </td>
            <td class="check-box th-plugin-line--value" (click)="update(obsolescence)">
              <i class="material-icons" *ngIf="!obsolescence.Recommended">check_box_outline_blank</i>
              <i
                class="material-icons"
                [class.disabled]="obsolescence.Urgency === 'high'"
                *ngIf="obsolescence.Recommended"
                >check_box</i
              >
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #empty>
  <h2>
    <span *ngIf="processing">{{ 'common.loading' | translate }}...</span>
    <span *ngIf="!processing">{{ 'plugins.upgrades.no-equipment' | translate }}</span>
  </h2>
</ng-template>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'Delete confirmation'"
  [message]="'Are you sure to delete this <strong>plugin</strong> ?'"
  [danger]="true"
></confirm>
